module.exports = __webpack_public_path__ + "static/media/bh.ef135f3c.svg";